import styled from 'styled-components';
import HotelHeadSvg from '../../assets/header/hotelHeader.svg';

const HotelHeadIcon = styled(HotelHeadSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '3.3rem'};
  height: ${props => props.height || '3.3rem'};
  margin: ${props => props.margin};
  fill: ${props => props.fill};
`;

export default HotelHeadIcon;
